import { AppError } from '@app/domain/entities';

/**
 * Thrown when PGP encryption or decryption of a backup file fails.
 * `operation` distinguishes encrypt from decrypt so the log and toast can be
 * specific about which direction failed.
 */
export class BackupEncryptionError extends AppError {
  readonly code = 'E_BACKUP_ENCRYPT';

  constructor(
    public readonly operation: 'encrypt' | 'decrypt',
    message?: string,
    cause?: unknown,
  ) {
    super(message ?? `Failed to ${operation} backup`, { operation }, { cause });
  }
}

export class BackupAuthError extends AppError {
  readonly code = 'E_BACKUP_AUTH_FAILED';

  constructor() {
    super('Backup authorization failed.');
  }
}
